import { FC } from 'react';

import bottomDecor from 'media/wrapped/bottom-decor.svg';
import centerDecor from 'media/wrapped/center-decor.svg';
import leftDecor from 'media/wrapped/left-decor.svg';
import topDecor from 'media/wrapped/top-decor.svg';
import wrappedBg from 'media/wrapped/wrapped-bg.svg';

import { formatCurrencyToShort, padNumber } from 'utils/format-helper';

interface WrappedCollageProps {
  className?: string;
  wrappedData: any[];
  syndicateName?: string | null;
}

const WrappedCollage: FC<WrappedCollageProps> = ({
  className = '',
  wrappedData,
  syndicateName,
}) => {
  return (
    <div
      id="wrapped-collage"
      style={{
        backgroundImage: `url(${wrappedBg})`,
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
      className={`group ${className} w-[1920px] h-[1080px] rounded-xl p-12`}
    >
      <div className="grid grid-cols-6 gap-4 w-full h-full pt-12 pb-24 px-56">
        {wrappedData.map((item, index) => (
          <div
            key={index}
            className={`col-span-2 row-span-2 h-full rounded-xl border-2 overflow-hidden relative`}
          >
            <div className={`bg-[#161515] backdrop-blur-sm h-full relative`}>
              {/* DECORATIONS */}
              <div>
                <img
                  src={topDecor}
                  alt="top-decor"
                  className="absolute top-0 right-0 h-24 w-24 opacity-50"
                />
                <img
                  src={bottomDecor}
                  alt="bottom-decor"
                  className="absolute bottom-0 right-0 h-24 w-24"
                />
                <img
                  src={centerDecor}
                  alt="center-decor"
                  className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 h-64 w-64 opacity-30"
                />
                <img
                  src={leftDecor}
                  alt="left-decor"
                  className="absolute top-1/3 -left-40 transform -translate-y-1/2 h-64 w-64 opacity-10"
                />
                <span className="absolute bottom-12 pb-1 left-10 text-white font-bold text-sm">
                  {syndicateName}
                </span>
              </div>
              {/* DECORATIONS */}
              <div className="flex justify-between flex-col h-full p-10">
                <h2
                  style={{
                    color: `#C9A876`,
                  }}
                  className="text-xl uppercase font-bold mb-3 drop-shadow-lg text-left"
                >
                  {wrappedData[index].title}
                </h2>
                <div className="relative z-10 space-y-3 font-bold text-white text-center tracking-tight">
                  {wrappedData[index].format === 'ARRAY' ? (
                    <div className="text-3xl">
                      <ul className="list-decimal list-inside">
                        {wrappedData[index].value.map((val: any, idx: number) => (
                          <li key={idx}>{val}</li>
                        ))}
                      </ul>
                    </div>
                  ) : null}
                  {wrappedData[index].format === 'CURRENCY' ? (
                    <p className="text-7xl">{formatCurrencyToShort(wrappedData[index].value)} </p>
                  ) : null}
                  {wrappedData[index].format === 'NUMBER' ? (
                    <p className="text-7xl">{padNumber(wrappedData[index].value)} </p>
                  ) : null}
                  {wrappedData[index].format === 'SMALL_STRING' ? (
                    <p className="text-3xl">{wrappedData[index].value} </p>
                  ) : null}
                </div>
                <div className="flex items-center gap-2">
                  <div className="flex-grow h-0.5 bg-gradient-to-r from-white/40 to-transparent rounded-full"></div>
                  <span className="text-xs text-white font-medium">2025</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WrappedCollage;
